module.exports = __webpack_public_path__ + "img/b9445a9.jpg";